import React from "react";

import { phoneNumberSort } from "../../../util/sort.js";

/**
 * @typedef {import("../../../jsdoc/Contract.js").Contract} Contract
 */

/**
 * @param {Object} props
 * @param {string} props.chInfoSeq
 * @param {string} props.companyName
 * @param {string} props.displayName
 * @param {Contract[]} props.contracts
 * @param {string} props.position
 * @param {string} props.firstName
 * @param {string} props.lastName
 * @param {string} props.email
 * @param {{contactPhoneSeq: number, phone: string}[]} props.phoneNumbers
 * @returns {React.JSX.Element} Program Managers Table Entry Component
 */
export default function TableEntry({
  chInfoSeq,
  companyName,
  displayName,
  contracts,
  position,
  firstName,
  lastName,
  email,
  phoneNumbers,
}) {
  return (
    <tr role="row">
      <td className="text-center clickable" role="gridcell">
        <a href={`#/detail/${chInfoSeq}`} title={`Go to the detail page for ${displayName}`}>
          {`${companyName} (${displayName})`}
        </a>
      </td>
      <td className="text-center" role="gridcell">
        <ul className="list-unstyled">
          {contracts.map(({ chScnXrefSeq, sewpContractNumber }) => (
            <li key={chScnXrefSeq}>{sewpContractNumber}</li>
          ))}
        </ul>
      </td>
      <td className="text-center" role="gridcell">
        {position}
      </td>
      <td className="text-center" role="gridcell">{`${lastName}, ${firstName}`}</td>
      <td className="text-center" role="gridcell">
        <a href={`mailto:${email}`}>{email}</a>
      </td>
      <td role="gridcell">
        <ul className="list-unstyled">
          {phoneNumbers.sort(phoneNumberSort).map(({ contactPhoneSeq, phone, typeFlag }) => (
            <li key={contactPhoneSeq}>
              {phone} {typeFlag !== "Phone" && <span>{typeFlag.toLowerCase()}</span>}
            </li>
          ))}
        </ul>
      </td>
    </tr>
  );
}
